module.exports = __webpack_public_path__ + "static/media/ID.e330af15.mp4";